// Shared "create a layout + reseed an instance to point at it" tail for useSaveAsNewLayout and
// useDuplicateDashboard's self-heal branch. [APP-3309]
import { warn } from "helpers/dev-logger"
import type { Layout } from "resources/layouts"
import type { DashboardInstance } from "resources/dashboard-instances"
import type { LayoutConfigV1 } from "../contracts/layouts"

export interface CreateAndReseedLayoutArgs {
  dashboardId: string
  name: string
  config: LayoutConfigV1
  createLayout: (name: string, config: LayoutConfigV1) => Promise<Layout>
  reseedInstance: (instanceId: string, layoutId: string) => Promise<DashboardInstance>
}

// Callers own the registry upsert, resource-cache resets, and any follow-up steps.
// If reseed fails after the layout POST succeeds, the layout is orphaned — warned, not compensated.
export async function createAndReseedLayout({
  dashboardId,
  name,
  config,
  createLayout,
  reseedInstance,
}: CreateAndReseedLayoutArgs): Promise<DashboardInstance> {
  const layout = await createLayout(name, config)

  try {
    return await reseedInstance(dashboardId, layout.id)
  } catch (error) {
    warn(`Layout ${layout.id} created but reseed of instance ${dashboardId} failed — layout is now orphaned`, error)
    throw error
  }
}
